import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import type { User } from '@recruitee/account-types';

import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'rt-user-list-tooltip',
  template: `
    <p class="tooltip-heading" margin-bottom-small-xx data-cy="user-list-tooltip:heading">
      <ng-content select="[heading]" />
    </p>
    @for (user of sortableUsers(); track user.id) {
      <p class="user" layout data-cy="user-list-tooltip:user">
        <rt-avatar
          size="small-x"
          shape="oval"
          [type]="user.hasAvatar ? 'image' : 'initials'"
          [initials]="user.initials"
          [imageSrc]="user.photoThumbUrl"
          context="admin"
          margin-top-small-xx
          data-cy="user-list-tooltip:user:avatar"
        />
        <span margin-left-small-x data-cy="user-list-tooltip:user:name">
          {{ user.firstName + '&nbsp;' + user.lastName }}
        </span>
      </p>
    }
  `,
  styleUrl: 'user-list-tooltip.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent],
})
export class UserListTooltipComponent {
  protected readonly sortableUsers = computed(() =>
    this.sortByName()
      ? [...this.users()].sort((a, b) =>
          `${a.firstName}${a.lastName}`.localeCompare(`${b.firstName}${b.lastName}`),
        )
      : this.users(),
  );

  public readonly users = input.required<User[]>();

  public readonly sortByName = input<boolean, boolean | string>(true, {
    transform: booleanAttribute,
  });
}
